export const colorScheme = {
  progressBar: "#05DD80",
  progressBarDots: "#01d77b",
};
